import React, { useState, useRef, useEffect } from "react";
import {
  FaFolder,
  FaFile,
  FaImage,
  FaFilePdf,
  FaFileWord,
  FaFileCode,
  FaFileAlt,
  FaFileExcel,
  FaArrowUp,
  FaArrowDown,
  FaEllipsisV,
  FaFileVideo,
  FaFileAudio,
  FaFileArchive,
  FaJs,
  FaReact,
  FaNodeJs,
  FaPhp,
  FaPython,
  FaJava,
  FaDatabase,
  FaCode,
  FaHtml5,
  FaCss3Alt,
  FaCuttlefish,
  FaFileCsv,
  FaEyeSlash,
  FaEye,
  FaAngleRight,
} from "react-icons/fa";
import "./Folder.scss";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import { useLazyQuery, useMutation } from "@apollo/client";
import Reactportal from "../../Components/Reactportal/Reactportal";
import axios from "axios";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import { FaC } from "react-icons/fa6";
import HeaderDrive from "./HeaderDrive";
import "./Toastt";

import {
  Create_File,
  CREATE_FOLDER_MUTATION,
  DELETE_FILE_OR_FOLDER,
  GET_FOLDERS_QUERY,
  GetRootFolder,
  Rename_File_And_Folder,
} from "../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import { RiErrorWarningFill } from "react-icons/ri";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { Bounce, ToastContainer } from "react-toastify";

function Folder() {
  const [layout, setLayout] = useState("list");
  const [sortColumn, setSortColumn] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [showModal, setShowModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [currentFolder, setCurrentFolder] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filePreview, setFilePreview] = useState(null);
  const [navStack, setNavStack] = useState([]);
  const fileInputRef = useRef(null);
  const folderInputRef = useRef(null);
  const [data, setData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const [folderId, setFolderId] = useState("");
  console.log(folderId, "folderIdfolderIdfolderIdfolderId");
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [currentItemToRename, setCurrentItemToRename] = useState(null);
  const [newName, setNewName] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const dropdownRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const searchRef = useRef(null);
  const containerRef = useRef(null);
  const [gridSize, setGridSize] = useState("medium");
  const [isDelete, setIsDelete] = useState(false);
  const [deletedItem, setDeletedItem] = useState({});
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isSecured, setIsSecured] = useState(false);

  const navigate = useNavigate();

  const folderLocation = useLocation();
  const params = new URLSearchParams(folderLocation?.search);
  console.log(folderLocation, "viwaaaaa");
  const getIdFromUrl = () => {
    const searchParams = new URLSearchParams(folderLocation.search);
    return searchParams.get("id");
  };

  const [getRootFolder] = useLazyQuery(GetRootFolder, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    const savedNavStack = JSON.parse(decodeURIComponent(params.get("data")));

    if (savedNavStack) {
      const parsedNavStack = savedNavStack;

      if (parsedNavStack.length > 0) {
        const lastFolder = parsedNavStack[parsedNavStack.length - 1];

        if (parsedNavStack.length === 1 && lastFolder.name === "Root") {
          setNavStack([{ _id: lastFolder._id, name: "Root" }]);

          const encodeData = encodeURIComponent([{ _id: lastFolder._id, name: "Root" }]);
          navigate(`/MyDrive?data=${encodeData}`);
        } else {
          setNavStack(parsedNavStack);
        }

        setFolderId(getIdFromUrl() || lastFolder._id);
      }
    } else {
      getRootFolder({ variables: { name: "Root" } }).then((res) => {
        if (res?.data?.getRootFolder) {
          setFolderId(getIdFromUrl() || res.data.getRootFolder._id);
          setNavStack([{ _id: res.data.getRootFolder._id, name: "Root" }]);
          const encodeData = encodeURIComponent([{ _id: res.data.getRootFolder._id, name: "Root" }]);
          //usr the encoded data as parameter in url
          // navigate(`/folder?data=${encodeData}`);
          // sessionStorage.setItem("navStack", JSON.stringify([{ _id: res.data.getRootFolder._id, name: "Root" }]));
        }
      });
    }
  }, []);

  // useEffect(() => {
  //   getRootFolder({ variables: { name: "Root" } }).then((res) => {
  //     if (res?.data?.getRootFolder) {
  //       setFolderId(getIdFromUrl() || res.data.getRootFolder._id);
  //     }
  //   });
  // }, []);

  const handleSetGridSize = (size) => {
    setGridSize(size);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchResults([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [createFolder] = useMutation(CREATE_FOLDER_MUTATION, {
    onError: (error) => {
      alert("Error creating folder: " + error.message);
    },
  });

  const [createFile, { data: createdata }] = useMutation(Create_File, {
    onError: (error) => {
      console.error("Error creating file:", error);
      alert("Error creating file: " + error.message);
    },
  });

  const parseDate = (dateString) => {
    return dateString ? new Date(dateString) : new Date(0);
  };

  const [fetchFolders] = useLazyQuery(GET_FOLDERS_QUERY, {
    onCompleted: (data) => {
      if (data.getFolders) {
        setCurrentFolder({
          ...data.getFolders,
          items: sortItems(data.getFolders.items),
        });
      }
    },
    fetchPolicy: "network-only",
  });

  const [renameFunction] = useMutation(Rename_File_And_Folder, {
    onCompleted: (data) => {
      console.log("Folder renamed successfully:", data.renameFolder);
      setShowRenameModal(false);
    },
    onError: (error) => {
      alert("Error renaming folder: " + error.message);
    },
  });

  const [deleteFileOrFolder] = useMutation(DELETE_FILE_OR_FOLDER, {
    onCompleted: (data) => {
      // console.log("File/Folder deleted successfully:", data);
      const idsArray = navStack.map((el) => el._id);
      fetchFolders({ variables: { id: idsArray[idsArray.length - 1] } }).then((res) => {
        console.log(res.data, res, "res");
        if (res?.data?.getFolders) {
          setCurrentFolder({ ...res.data.getFolders, items: res.data.getFolders.items ?? [] });
        }
      });
    },
    onError: (error) => {
      alert("Error deleting file/folder: " + error.message);
    },
  });

  useEffect(() => {
    if (!folderId) return;

    fetchFolders({ variables: { id: folderId } }).then((res) => {
      if (res?.data?.getFolders) {
        setData(res.data.getFolders.items);

        setNavStack((prevStack) => {
          if (prevStack.some((folder) => folder._id === folderId)) {
            return prevStack;
          }

          return [...prevStack, res.data.getFolders];
        });

        setCurrentFolder({ ...res.data.getFolders, items: res.data.getFolders.items ?? [] });
      }
    });
  }, [folderId]);

  // useEffect(() => {
  //   console.log(folderId, "ssssssssss");

  //   fetchFolders({ variables: { id: folderId } }).then((res) => {
  //     console.log(res.data, res, "res");
  //     if (res?.data?.getFolders) {
  //       setData(res.data.getFolders.items);
  //       console.log(navStack, "navstack");
  //       setNavStack((prevStack) => [...prevStack, res.data.getFolders]);
  //       setCurrentFolder({ ...res.data.getFolders, items: res.data.getFolders.items ?? [] });
  //     }
  //   });
  // }, [folderId]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      setFolderId(getIdFromUrl());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const setIdInUrl = (id) => {
    navigate(`/MyDrive?id=${id}`, { replace: true });
  };

  const handleFolderClick = (folder) => {
    console.log("folders", folder);
    if (folder.fileUrl) {
      console.log("it is filee");
      return;
    }

    if (folder._id) {
      setFolderId(folder._id);
      setIdInUrl(folder._id);
      setNavStack((prevStack) => {
        const existingIndex = prevStack.findIndex((el) => el._id === folder._id);
        if (existingIndex !== -1) {
          return prevStack.slice(0, existingIndex + 1);
        }

        const newStack = [...prevStack, folder];
        sessionStorage.setItem("navStack", JSON.stringify(newStack));

        const data = newStack.map(({ _id, name }) => ({
          _id,
          name,
        }));
        const jsondata = JSON.stringify(data);

        const encodeData = encodeURIComponent(jsondata);

        navigate(`/MyDrive?data=${encodeData}`);

        return newStack;
      });
    }
  };

  const handleCreateFolder = async () => {
    if (!newFolderName.trim()) {
      alert("Folder name is required.");
      return;
    }
    try {
      console.log("Sending request to create folder with:", {
        name: newFolderName,
        parentFolderId: currentFolder ? currentFolder._id : null,
      });

      await createFolder({
        variables: {
          createInput: {
            name: newFolderName,
            parentFolderId: currentFolder ? currentFolder._id : null,
          },
        },
      });

      const idsArray = navStack.map((el) => el._id);
      fetchFolders({ variables: { id: idsArray[idsArray.length - 1] } }).then((res) => {
        console.log(res.data, res, "Res after creating folder");
        if (res?.data?.getFolders) {
          setCurrentFolder({ ...res.data.getFolders, items: res.data.getFolders.items ?? [] });
        }
      });

      setShowModal(false);
      setNewFolderName("");
    } catch (err) {
      console.error("Error creating folder:", err);
      alert("Error creating folder: " + err.message);
    }
  };

  const toggleLayout = (newTab) => {
    if (newTab === layout) {
      return;
    } else {
      const newLayout = layout === "list" ? "grid" : "list";
      setLayout(newLayout);
    }
  };

  const getFileIcon = (url, name) => {
    const iconStyles = { fontSize: "1rem" };

    if (!url || !url.includes(".")) {
      return <FaFolder style={{ ...iconStyles, color: "#505050" }} />;
    }

    const extension = name.split(".").pop().toLowerCase();

    if (extension === "pdf") {
      return <FaFilePdf style={{ ...iconStyles, color: "#FF0000" }} />;
    } else if (["doc", "docx", "odt"].includes(extension)) {
      return <FaFileWord style={{ ...iconStyles, color: "#2B579A" }} />;
    } else if (["xls", "xlsx", "ods"].includes(extension)) {
      return <FaFileExcel style={{ ...iconStyles, color: "#207245" }} />;
    } else if (extension === "csv") {
      return <FaFileCsv style={{ ...iconStyles, color: "#00A650" }} />;
    }

    const codeIcons = {
      js: <FaJs style={{ ...iconStyles, color: "#F7DF1E" }} />,
      jsx: <FaReact style={{ ...iconStyles, color: "#61DAFB" }} />,
      ts: <FaNodeJs style={{ ...iconStyles, color: "#3178C6" }} />,
      tsx: <FaNodeJs style={{ ...iconStyles, color: "#3178C6" }} />,
      php: <FaPhp style={{ ...iconStyles, color: "#777BB4" }} />,
      py: <FaPython style={{ ...iconStyles, color: "#3776AB" }} />,
      java: <FaJava style={{ ...iconStyles, color: "#007396" }} />,
      sql: <FaDatabase style={{ ...iconStyles, color: "#F29111" }} />,
      json: <FaCode style={{ ...iconStyles, color: "#CB3837" }} />,
      sh: <FaFileCode style={{ ...iconStyles, color: "#4E9A06" }} />,
      html: <FaHtml5 style={{ ...iconStyles, color: "#E34F26" }} />,
      css: <FaCss3Alt style={{ ...iconStyles, color: "#1572B6" }} />,
      scss: <FaCss3Alt style={{ ...iconStyles, color: "#CD6799" }} />,
      cpp: <FaCuttlefish style={{ ...iconStyles, color: "#00599C" }} />,
      c: <FaC style={{ ...iconStyles, color: "#00599C" }} />,
      cs: <FaC style={{ ...iconStyles, color: "#9C1A00" }} />,
      rb: <FaFileCode style={{ ...iconStyles, color: "#CC342D" }} />,
      go: <FaFileCode style={{ ...iconStyles, color: "#00ADD8" }} />,
      swift: <FaFileCode style={{ ...iconStyles, color: "#FFAC45" }} />,
      kt: <FaFileCode style={{ ...iconStyles, color: "#F88909" }} />,
    };

    if (codeIcons[extension]) {
      return codeIcons[extension];
    }

    if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension)) {
      return <FaImage style={{ ...iconStyles, color: "rgb(234, 67, 53)" }} />;
    }

    if (["mp3", "wav", "aac"].includes(extension)) {
      return <FaFileAudio style={{ ...iconStyles, color: "rgb(243, 88, 74)" }} />;
    }

    if (["mp4", "mov", "avi", "mkv"].includes(extension)) {
      return <FaFileVideo style={{ ...iconStyles, color: "#0000FF" }} />;
    }

    if (["zip", "rar", "7z", "tar", "gz"].includes(extension)) {
      return <FaFileArchive style={{ ...iconStyles, color: "#CC9900" }} />;
    }

    if (["txt", "log", "md"].includes(extension)) {
      return <FaFileAlt style={{ ...iconStyles, color: "#808080" }} />;
    }

    return <FaFile style={{ ...iconStyles, color: "#0b57d0" }} />;
  };

  const handleFileChange = async (event) => {
    let selectedFile = event.target.files[0];
    if (!selectedFile) {
      alert("Please select a file.");
      return;
    }

    let temp = window.location.pathname;
    let temp2 = temp.split("/");
    const formData = new FormData();
    formData.append("file", selectedFile);
    console.log(navStack);
    const idsArray = navStack.map((el) => el._id);
    console.log(idsArray);
    const CompanyCode = JSON.parse(sessionStorage.getItem("CompanyCode") || "{}");
    const company = CompanyCode?.CompanyCode;
    formData.append("path", `Folder/${company}/${idsArray.join("/")}`);
    console.log(temp2);

    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/upload/single`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          path: `Folder/${temp2[1]}`,
        },
      });
      console.log(data, "Gjjhkhfkejgkehgfua3hg");
      if (data.fileURL) {
        const newfile = {
          name: data.fileName,
          fileUrl: data.fileURL,
          size: data.fileSize,
          parentFolderId: idsArray[idsArray.length - 1],
        };

        const uploadpromise = new Promise(async (resolve, reject) => {
          try {
            await createFile({ variables: { createInput: newfile } })
              .then(() => {
                fetchFolders({ variables: { id: idsArray[idsArray.length - 1] } }).then((res) => {
                  resolve("File uploaded successfully!");
                  console.log(res.data, res, "res");
                  if (res?.data?.getFolders) {
                    setCurrentFolder({ ...res.data.getFolders, items: res.data.getFolders.items ?? [] });
                    console.log(navStack, "navstack");
                  }
                });
              })
              .catch(() => {
                throw new Error("File upload failed.");
              });
          } catch (error) {
            console.log(error, "errorerrorerrorerrorerrorerror");
            reject("File upload failed. Please try again.");
          }
        });
        toast.promise(uploadpromise, {
          pending: "Uploading file...",
          success: "File uploaded successfully!!1111111111111111111111111111",
          error: "File upload failed. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      ErrorToast("Error uploading file: " + error.message);
    }

    event.target.value = null;
  };

  const handleNavigate = (folder, index) => {
    if (!folder) return;

    if (folder._id) {
      setFolderId(folder._id);
      setIdInUrl(folder._id);

      // Slice `navStack` to maintain correct path when going back
      setNavStack((prevStack) => {
        const newStack = prevStack.slice(0, index + 1); // Preserve only up to selected folder
        sessionStorage.setItem("navStack", JSON.stringify(newStack)); // Update session storage
        return newStack;
      });
    }
  };

  const getFileType = async (fileUrl) => {
    let fileType = "";

    // Check if the URL has an extension
    const urlParts = fileUrl.split(".");
    const hasExtension = urlParts.length > 1 && urlParts[urlParts.length - 1].length <= 5;

    if (hasExtension) {
      fileType = urlParts.pop().split("?")[0].toLowerCase();
    }

    // If no valid extension found, fetch MIME type
    if (!fileType || fileType.length > 5) {
      try {
        const response = await fetch(fileUrl, { method: "HEAD" });
        const contentType = response.headers.get("Content-Type");
        console.log("Fetched Content-Type:", contentType);

        // MIME Type to File Extension Mapping
        const mimeMap = {
          "application/pdf": "pdf",
          "text/plain": "txt",
          "application/msword": "doc",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
          "application/vnd.ms-excel": "xls",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
          "application/vnd.ms-powerpoint": "ppt",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
          "image/png": "png",
          "image/jpeg": "jpg",
          "image/gif": "gif",
          "image/svg+xml": "svg",
          "image/tiff": "tiff",
          "image/x-tiff": "tiff",
          "audio/mpeg": "mp3",
          "video/mp4": "mp4",
          "video/x-msvideo": "avi",
          "application/zip": "zip",
          "application/x-rar-compressed": "rar",
          "application/json": "json",
          "text/html": "html",
          "text/css": "css",
          "text/javascript": "js",
          "application/x-sh": "sh",
          "application/x-tar": "tar",
          "text/csv": "csv",
          "application/vnd.oasis.opendocument.text": "odt",
          "application/vnd.oasis.opendocument.spreadsheet": "ods",
        };

        // Assign fileType based on MIME type lookup
        fileType = mimeMap[contentType] || "unknown";
      } catch (error) {
        console.error("Error fetching file metadata:", error);
        fileType = "unknown";
      }
    }

    return fileType;
  };

  const handleFileClick = async (file) => {
    console.log("File clicked:", file);

    if (!file.fileUrl) return;

    let fileType = await getFileType(file.fileUrl); // Use the improved function
    console.log(fileType);

    if (fileType === "unknown") {
      alert("This file type is not recognized. Downloading...");
      window.open(file.fileUrl, "_blank");
      return;
    }

    if (fileType === "tiff" || fileType === "tif" || fileType === "avi" || fileType === "wmv" || fileType === "flv") {
      alert("This type of files are not viewable in the browser. Please download and open them in an image viewer.");
      window.open(file.fileUrl, "_self");
      return;
    }

    console.log(fileType);

    const googleViewerTypes = ["pdf", "txt", "rtf"];
    const googleDocsFileTypes = ["doc", "docx", "xls", "xlsx", "ppt"];
    const googleOdtDocsFileTypes = ["odt", "odp", "ods"];

    const imageTypes = ["png", "jpg", "jpeg", "gif", "bmp", "svg", "webp", "avif", "ico"];
    const audioTypes = ["mp3", "wav", "aac", "ogg", "flac"];
    const videoTypes = ["mp4", "mov", "avi", "mkv", "flv", "wmv"];
    const codingFileTypes = [
      "js",
      "php",
      "css",
      "scss",
      "sass",
      "yml",
      "yaml",
      "py",
      "c",
      "jsx",
      "java",
      "sql",
      "xml",
      "tsx",
      "ts",
      "cpp",
      "cs",
      "rb",
      "go",
      "swift",
      "kt",
      "json",
      "sh",
      "html",
      "md",
      "txt",
      "h",
    ];
    const zipFiles = [
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "exe",
      "dmg",
      "apk",
      "bat",
      "msi",
      "tgz",
      "deb",
      "tex",
      "md",
      "spec",
      "torrent",
      "ics",
      "ttf",
      "woff",
    ];
    const csvFiles = ["csv"];
    const diskImageFiles = ["iso", "bin"];
    const databaseFiles = ["db", "sqlite", "sqlitedb"];

    if (googleViewerTypes.includes(fileType)) {
      // Open PDF in Google Drive Viewer
      const docsUrl = `https://drive.google.com/viewerng/viewer?url=${encodeURIComponent(file.fileUrl)}&embedded=true`;
      openInNewTab(docsUrl);
    } else if (googleDocsFileTypes.includes(fileType)) {
      const docsUrl = `https://docs.google.com/gview?url=${encodeURIComponent(file.fileUrl)}&embedded=true`;
      openInNewTab(docsUrl);
    } else if (googleOdtDocsFileTypes.includes(fileType)) {
      setTimeout(() => {
        openInNewTab(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(file.fileUrl)}`);
      }, 1000);
    } else if (imageTypes.includes(fileType)) {
      setSelectedFile({
        type: "image",
        url: file.fileUrl,
      });
    } else if (audioTypes.includes(fileType)) {
      setSelectedFile({
        type: "audio",
        url: file.fileUrl,
      });
    } else if (videoTypes.includes(fileType)) {
      setSelectedFile({
        type: "video",
        url: file.fileUrl,
      });
    } else if (codingFileTypes.includes(fileType)) {
      try {
        const response = await fetch(file.fileUrl);
        if (!response.ok) throw new Error("Failed to fetch file");

        const text = await response.text();
        setSelectedFile({
          type: "code",
          content: text,
          fileType: fileType,
          name: file.name,
        });
      } catch (error) {
        alert("Error loading file content.");
      }
    } else if (csvFiles.includes(fileType)) {
      try {
        const response = await fetch(file.fileUrl);
        if (!response.ok) throw new Error("Failed to fetch file");

        const csvText = await response.text();
        setSelectedFile({
          type: "csv",
          content: csvText,
          name: file.name,
        });
      } catch (error) {
        alert("Error loading CSV file.");
      }
    } else if (zipFiles.includes(fileType)) {
      setSelectedFile({
        type: "zip",
        url: file.fileUrl,
        name: file.name,
      });
    } else if (codingFileTypes.includes(fileType)) {
      try {
        const response = await fetch(file.fileUrl);
        if (!response.ok) throw new Error("Failed to fetch file");

        const text = await response.text();
        setSelectedFile({
          type: "code",
          content: text,
          fileType: fileType,
          name: file.name,
        });
      } catch (error) {
        alert("Error loading file content.");
      }
    } else if (diskImageFiles.includes(fileType) || databaseFiles.includes(fileType)) {
      setSelectedFile({
        type: "download",
        url: file.fileUrl,
        name: file.name,
      });
    } else {
      setSelectedFile(file);
    }
  };

  function openInNewTab(url) {
    const newTab = window.open(url, "_blank");
    if (!newTab) {
      alert("Pop-up blocker is preventing the file from opening. Please disable your pop-up blocker and try again.");
    }
  }

  const closeModal = () => {
    setSelectedFile(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (!event.target.closest(".new-folder-btn")) {
          setDropdownVisible(false);
        }
      }

      if (openDropdownId !== null && (!dropdownRef.current || !dropdownRef.current.contains(event.target))) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownId, dropdownVisible]);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const sortItems = (items, column, direction) => {
    return items.sort((a, b) => {
      const isAFolder = !a.fileUrl;
      const isBFolder = !b.fileUrl;

      if (isAFolder && !isBFolder) return -1;
      if (!isAFolder && isBFolder) return 1;

      if (column === "name") {
        return direction === "asc"
          ? a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          : b.name.toLowerCase().localeCompare(a.name.toLowerCase());
      } else if (column === "modified") {
        const dateA = new Date(a.updatedAt || a.createdAt);
        const dateB = new Date(b.updatedAt || b.createdAt);
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      } else if (column === "size") {
        const sizeA = a.size ? parseFloat(a.size) : 0;
        const sizeB = b.size ? parseFloat(b.size) : 0;
        return direction === "asc" ? sizeA - sizeB : sizeB - sizeA;
      }
    });
  };

  const toggleSortDirection = (column) => {
    setSortColumn(column);
    setSortDirection((prevDirection) => {
      const newDirection = prevDirection === "asc" ? "desc" : "asc";

      if (currentFolder) {
        setCurrentFolder((prevFolder) => ({
          ...prevFolder,
          items: sortItems([...prevFolder.items], column, newDirection),
        }));
      }

      return newDirection;
    });
  };

  const closeDropdown = () => {
    setDropdownVisible(false);
  };

  const handleFolderAction = (action) => {
    closeDropdown();
    if (action === "newFolder") {
      setShowModal(true);
    } else if (action === "addFile") {
      fileInputRef.current.click();
    } else if (action === "uploadFolder") {
      folderInputRef.current.click();
    }
  };

  const toggleDrop = (id) => {
    if (openDropdownId === id) {
      setOpenDropdownId(null);
    } else {
      setOpenDropdownId(id);
    }
  };

  const handleRename = (item) => {
    renameFunction({
      variables: {
        editInput: {
          Id: currentItemToRename._id,
          name: newName,
        },
      },
    }).then(() => {
      const idsArray = navStack.map((el) => el._id);
      console.log(navStack, "navvvvvvv");
      fetchFolders({ variables: { id: idsArray[idsArray.length - 1] } }).then((res) => {
        console.log(res.data, res, "res");
        if (res?.data?.getFolders) {
          setCurrentFolder({ ...res.data.getFolders, items: res.data.getFolders.items ?? [] });
          console.log(navStack, "navstack");
        }
      });
    });
  };

  const handleDelete = (item) => {
    setIsDelete(true);
    setDeletedItem(item);
  };

  const handleConfirmDelete = () => {
    console.log(deletedItem, "deletedItem");
    deleteFileOrFolder({
      variables: {
        deleteInput: {
          Id: deletedItem._id,
        },
      },
    })
      .then(() => {
        setIsDelete(false);
        SuccessToast("Successfully deleted");
      })
      .catch((err) => {
        setIsDelete(false);
        ErrorToast("Error while deleting the item");
      });
  };

  const handleDownload = (file) => {
    window.open(file.fileUrl, "_self");
  };
  const openRenameModal = (item) => {
    setCurrentItemToRename(item);
    setNewName(item.name);
    setShowRenameModal(true);
  };

  const handleCloseActionBar = () => {
    setSelectedItems([]);
  };

  const handleDownloadSelected = () => {
    console.log("Downloading selected items:", selectedItems);
  };

  const handleDeleteSelected = () => {
    console.log("Deleting selected items:", selectedItems);
    selectedItems.forEach((item) => handleDelete(item));
    setSelectedItems([]);
  };

  let clickTimeout = null;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setSelectedItems([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSingleClick = (item, event) => {
    console.log(item, selectedItems);
    const isAlreadySelected = selectedItems.some((selected) => selected._id === item._id);

    if (isAlreadySelected) {
      setSelectedItems(selectedItems.filter((selected) => selected._id !== item._id));
    } else if (event.ctrlKey) {
      setSelectedItems((prev) =>
        prev.some((selected) => selected._id === item._id)
          ? prev.filter((selected) => selected._id !== item._id)
          : [...prev, item]
      );
    } else {
      setSelectedItems([item]);
    }
  };

  const handleDoubleClick = (item) => {
    clearTimeout(clickTimeout);
    if (item.fileUrl) {
      handleFileClick(item);
    } else {
      handleFolderClick(item);
    }
  };

  const screenWidth = window.innerWidth;
  const occupiedWidth = 182;
  const maxWidth = screenWidth - occupiedWidth;

  const handleSearch = (event) => {
    const query = event.target.value.trim().toLowerCase();
    setSearchQuery(query);

    if (query === "") {
      setSearchResults([]);
      return;
    }

    const results = currentFolder?.items.filter((item) => {
      const fileName = item.name.toLowerCase();
      if (fileName.startsWith(query)) return true;

      const words = fileName.split(/[_\s.-]+/);
      return words.includes(query);
    });

    setSearchResults(results);
  };

  const handleResultClick = (item) => {
    if (!item.fileUrl) {
      handleFolderClick(item);
    } else {
      handleFileClick(item);
    }
    setSearchQuery("");
    setSearchResults([]);
  };

  const isCancle = () => {
    setShowModal(false);
    setIsSecured(false);
    setPassword("");
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      handleformclose={() => {
        setSelectedFile(null);
      }}
    />
  );

  if (isDelete) {
    return (
      <Reactportal open={true} onClose={() => setIsDelete(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={() => {
            handleConfirmDelete();
          }}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            setIsDelete(false);
          }}
        />
      </Reactportal>
    );
  }

  return (
    <div className="drive-container-folder-drive">
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />

      <HeaderDrive
        toggleDropdown={toggleDropdown}
        dropdownVisible={dropdownVisible}
        searchQuery={searchQuery}
        handleSearch={handleSearch}
        layout={layout}
        toggleLayout={toggleLayout}
        sortColumn={sortColumn}
        toggleSortDirection={toggleSortDirection}
        handleFolderAction={handleFolderAction}
        handleResultClick={handleResultClick}
        searchResults={searchResults}
        searchRef={searchRef}
        getFileIcon={getFileIcon}
        setGridSize={handleSetGridSize}
        dropdownRef={dropdownRef}
      />

      {/* {selectedItems.length > 0 && (
        <div className="action-bar">
          <div className="action-bar-content">
            <button className="close-button" onClick={handleCloseActionBar}>
              <FaTimes />
            </button>
            <span className="selected-count">{selectedItems.length} selected</span>
            <button className="action-icon" onClick={handleDownloadSelected}>
              <FaDownload />
            </button>
            <button className="action-icon" onClick={handleDeleteSelected}>
              <FaTrash />
            </button>
          </div>
        </div>
      )} */}

      {/* {showModal && (
        <div className="modal">
          <div className="modal-content-wrapper">
            <div className="modal-content">
              <label>New folder</label>
              <input
                type="text"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleCreateFolder()}
                placeholder="Folder name"
                autoFocus
              />
              <div className="modal-buttons-wrapper">
                <div className="modal-buttons">
                  <button onClick={() => setShowModal(false)}>Cancel</button>
                  <button onClick={handleCreateFolder} disabled={!newFolderName}>
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {showModal && (
        <div className="modal">
          <div className="modal-content-wrapper">
            <div className="modal-content">
              <label>New folder</label>
              <label className="modal-content-Folder-name-label" htmlFor="password">
                Folder Name
              </label>
              <input
                type="text"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleCreateFolder()}
                placeholder="Folder name"
                autoFocus
              />
              <div className="modal-buttons-wrapper">
                <div className="checkbox-containerddd">
                  <label htmlFor="secured-checkbox">Is Secure</label>
                  <input
                    className="CheckBoxInputOfISSecure"
                    type="checkbox"
                    id="secured-checkbox"
                    checked={isSecured}
                    onChange={(e) => setIsSecured(e.target.checked)}
                  />
                </div>
                {isSecured && (
                  <div className="password-containerddd">
                    <label className="password-containerddd-label" htmlFor="password">
                      Password
                    </label>
                    <div className="password-input-wrapper">
                      <input
                        className="folderPassword"
                        id="password"
                        type={passwordVisible ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter password"
                      />
                      {passwordVisible ? (
                        <FaEye className="password-icon" onClick={() => setPasswordVisible(!passwordVisible)} />
                      ) : (
                        <FaEyeSlash className="password-icon" onClick={() => setPasswordVisible(!passwordVisible)} />
                      )}
                    </div>
                  </div>
                )}
                <div className="modal-buttons">
                  <button onClick={isCancle}>Cancel</button>
                  <button onClick={handleCreateFolder} disabled={!newFolderName}>
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showRenameModal && (
        <div className="modal">
          <div className="modal-content-wrapper">
            <div className="modal-content">
              <label>Rename {currentItemToRename?.isFolder ? "Folder" : "File"}</label>
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleRename()}
                placeholder="Enter new name"
                autoFocus
              />
              <div className="modal-buttons-wrapper">
                <div className="modal-buttons">
                  <button onClick={() => setShowRenameModal(false)}>Cancel</button>
                  <button onClick={handleRename} disabled={!newName}>
                    Rename
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedFile && (
        <Reactportal FoooterContent={footerContent} open={true} onClose={closeModal} TypeOfPortal={"File Preview"}>
          <div className="Modal_Main_Container_Of_Files">
            {selectedFile.type === "image" ? (
              <img src={selectedFile.url} alt="Preview" />
            ) : selectedFile.type === "audio" ? (
              <audio controls>
                <source src={selectedFile.url} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            ) : selectedFile.type === "video" ? (
              <video controls>
                <source src={selectedFile.url} type={selectedFile.mimeType || "video/mp4"} />
                Your browser does not support the video tag.
              </video>
            ) : selectedFile.type === "csv" ? (
              <div>
                <h4>{selectedFile.name}</h4>
                <table border="1" cellPadding="5" cellSpacing="0">
                  {selectedFile.content.split("\n").map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.split(",").map((col, colIndex) => (
                        <td key={colIndex}>{col}</td>
                      ))}
                    </tr>
                  ))}
                </table>
              </div>
            ) : selectedFile.type === "zip" ? (
              <div className="zip">
                <h4>{selectedFile.name}</h4>
                <p>This type of file cannot be previewed directly.</p>
                <a href={selectedFile.url} download>
                  <button>Download ZIP</button>
                </a>
              </div>
            ) : selectedFile.type === "code" ? (
              <div className="code-container">
                <h4>{selectedFile.name}</h4>
                <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                  <code>{selectedFile.content}</code>
                </pre>
              </div>
            ) : (
              <p>Cannot preview this file type.</p>
            )}
          </div>
        </Reactportal>
      )}

      <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} multiple />
      <input
        type="file"
        ref={folderInputRef}
        style={{ display: "none" }}
        // onChange={handleFolderUpload}
        webkitdirectory="true"
        multiple
      />

      {filePreview && (
        <div className="file-preview-modal">
          <div
            className={`file-preview-container ${
              filePreview.type === "audio" || filePreview.type === "zip"
                ? "narrow"
                : filePreview.type === "image" || filePreview.type === "video"
                ? "wide"
                : ""
            }`}
          >
            {filePreview.type === "image" && <img src={filePreview.url} alt="Preview" />}
            {filePreview.type === "pdf" && <iframe src={filePreview.url} width="100%" height="500px" />}
            {filePreview.type === "audio" && (
              <audio controls>
                <source src={filePreview.url} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            )}
            {filePreview.type === "video" && (
              <video controls width="100%">
                <source src={filePreview.url} type="video/mp4" />
                Your browser does not support the video element.
              </video>
            )}
            {filePreview.type === "excel" && (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(filePreview.url)}`}
                width="100%"
                height="500px"
              />
            )}
            {filePreview.type === "word" && (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(filePreview.url)}`}
                width="100%"
                height="500px"
              />
            )}
            {filePreview.type === "zip" && (
              <div>
                <p>ZIP files cannot be previewed directly. Click below to download:</p>
                <a href={filePreview.url} download>
                  Download ZIP
                </a>
              </div>
            )}
            <div>
              <button onClick={() => setFilePreview(null)}>Close</button>
            </div>
          </div>
        </div>
      )}

      <div className={`folder-list-wrapper ${layout}`}>
        {currentFolder && navStack.length > 0 && (
          <div className="back-btn-wrapper">
            {navStack.map((el, index) => (
              <React.Fragment key={index}>
                <button
                  style={{ border: "none", backgroundColor: "white" }}
                  onClick={() => handleNavigate(el, index)}
                  className="back-btn"
                >
                  {el.name}
                </button>

                {index < navStack.length - 1 && (
                  <span className="breadcrumb-separator">
                    {" "}
                    <FaAngleRight />{" "}
                  </span>
                )}
              </React.Fragment>
            ))}
          </div>
        )}

        {layout === "list" ? (
          <div>
            <table className="Drive_Container_Table">
              <thead className="Drive_Container_Table_Head">
                <tr>
                  <th onClick={() => toggleSortDirection("name")}>
                    Name {sortColumn === "name" ? sortDirection === "asc" ? <FaArrowUp /> : <FaArrowDown /> : null}
                  </th>
                  <th onClick={() => toggleSortDirection("modified")}>
                    Last Modified{" "}
                    {sortColumn === "modified" ? sortDirection === "asc" ? <FaArrowUp /> : <FaArrowDown /> : null}
                  </th>
                  <th onClick={() => toggleSortDirection("size")}>
                    File Size {sortColumn === "size" ? sortDirection === "asc" ? <FaArrowUp /> : <FaArrowDown /> : null}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody ref={containerRef} className="Drive_Container_Table_Body">
                {currentFolder?.items.map((item, index) => (
                  <tr
                    key={index}
                    className={selectedItems.some((selected) => selected._id === item._id) ? "folder-row-selected" : ""}
                    onClick={(event) => handleSingleClick(item, event)}
                    onDoubleClick={() => handleDoubleClick(item)}
                  >
                    <td className="folder-name">
                      {getFileIcon(item.fileUrl, item.name)} {item.name}
                    </td>
                    <td>{IsoToDateTime(item.updatedAt)}</td>
                    <td className="folder-size"> {item.size ? parseFloat(item.size).toFixed(2) : "0.00"} MB</td>
                    <td className="parent_action_menu_container">
                      <FaEllipsisV onClick={() => toggleDrop(item._id)} />
                      {openDropdownId === item._id && (
                        <div className="action-menu" ref={dropdownRef}>
                          <button onClick={() => openRenameModal(item)}>Rename</button>
                          <button onClick={() => handleDelete(item)}>Delete</button>
                          {item.fileUrl && <button onClick={() => handleDownload(item)}>Download</button>}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="grid-view">
            {currentFolder?.items.some((item) => !item.fileUrl) && <h3 className="section-title">Folders</h3>}
            <div className={`grid-folder-container ${gridSize}`}>
              {currentFolder?.items
                .filter((item) => !item.fileUrl) // Only Folders
                .map((folder, index) => (
                  <div
                    key={index}
                    className="grid-item"
                    onClick={(event) => handleSingleClick(folder, event)}
                    onDoubleClick={() => handleFolderClick(folder)}
                  >
                    {getFileIcon(folder.fileUrl, folder.name)}
                    <span className="grid-item-name">{folder.name}</span>

                    <button
                      className="grid-action-menu"
                      onClick={(e) => {
                        console.log(folder);
                        toggleDrop(folder._id);
                        console.log(openDropdownId, folder._id, openDropdownId === folder._id);
                      }}
                    >
                      <FaEllipsisV style={{ fontSize: "14px", color: "#4a4a4a" }} />
                    </button>

                    {openDropdownId === folder._id && (
                      <div className="dropdown-menu" ref={dropdownRef}>
                        {console.log("Dropdown is open for folder:", openDropdownId, folder._id)}
                        <button onClick={() => openRenameModal(folder)}>Rename</button>
                        <button onClick={() => handleDelete(folder)}>Delete</button>
                      </div>
                    )}
                  </div>
                ))}
            </div>

            {/*  Render Files Below */}
            {currentFolder?.items.some((item) => item.fileUrl) && <h3 className="section-title">Files</h3>}
            <div className={`grid-file-container ${gridSize}`}>
              {currentFolder?.items
                .filter((item) => item.fileUrl)
                .map((file, index) => (
                  <div
                    key={index}
                    className="grid-item"
                    onClick={(event) => handleSingleClick(file, event)}
                    onDoubleClick={() => handleDoubleClick(file)}
                  >
                    {getFileIcon(file.fileUrl, file.name)}
                    <span className="grid-item-name">{file.name}</span>

                    <button className="grid-action-menu" onClick={(e) => toggleDrop(file._id, e)}>
                      <FaEllipsisV style={{ fontSize: "14px", color: "#4a4a4a" }} />
                    </button>

                    {openDropdownId === file._id && (
                      <div className="dropdown-menu" ref={dropdownRef}>
                        <button onClick={() => openRenameModal(file)}>Rename</button>
                        <button onClick={() => handleDelete(file)}>Delete</button>
                        <button onClick={() => handleDownload(file)}>Download</button>
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Folder;
